<div class="job-posts placements agreements margin-top-service-30px">
  <div class="card skillassest-form">

  </div>
  <div class="card-body padding-top padding-left-0px padding-right-0px">
    <div class="row margin-left-0px margin-right-0px">

      <div class="col-md-12">
        <div class="card">

        </div>
        <div class="row">
          <div class="col-md-12 padding-left-0px">
            <div class="card">
              <div class="card-header wh-header border-bottom bk-color-lightgray">
                <div class="row">
                  <div class="col-md-2 padding-right-0px">
                    <label class="label-size-2 font-color-secondary">Services List</label>
                  </div>
                  <div class="col-md-3 text-align-left">

                  </div>
                  <div class="col-md-6 padding-left-0px">
                    <div class="row margin-left-zero margin-right-0px">

                      <div class="col-md-3 margin-left-auto padding-right-0px">
                        <button type="button" class="btn btn-primary btn-sm margin-right-10px" hidden><i class="fas fa-plus nav-link-hand"></i></button>
                        <button type="button" class="btn  btn-detail btn-sm" hidden><i class="fas fa-list nav-link-hand"></i></button>
                      </div>
                      
                      <div class="col-md-4 padding-right-0px padding-left-0px margin-right-8p">
                        <div class="row">
                          <div class="col-md-1">
                            <button type="button" (click)="AddNewService()"
                                    class="btn btn-sm button-new-health2" tooltip="Add" title="Add New Service"
                                    *canUserAccess="['HL_ER_11']">
                              <i class="fas fa-plus nav-link-hand"></i>
                            </button>
                          </div>
                          <div class="col-md-9 padding-right-0px">
                            <search-list [title]="searchTitle" [hideTitle]="1" (input)="criteriaChange($event.target.value)"></search-list>
                          </div>
                          <div class="col-md-1 padding-left-6px">
                            <a *ngIf="CurrentServicesByCategoryCodeController2">
                              <div class="badge badge-search">
                                <label class="margin-bottom-4px margin-top-4px">
                                  {{CurrentServicesByCategoryCodeController2.length}}
                                </label>
                              </div>
                            </a>
                          </div>

                        </div>
                       
                      </div>
                      
                    </div>
                  </div>

                </div>
              </div>
              <div class="card-body">
                <div class="table-component">
                  <div class="table-responsive overflow-x-hidden">


                    <table class="table table-striped margin-left-zero">

                      <thead class="">
                        <tr>
                          <th class="td-width-3px padding-top-0px padding-bottom-0px">Code</th>
                          <th class="padding-top-0px padding-bottom-0px">Name</th>
                          <th class="padding-top-0px padding-bottom-0px">Service Category</th>
                          <th class="padding-top-0px padding-bottom-0px">Revenue Category</th>
                          <th class="td-width-3px padding-top-0px padding-bottom-0px">Service Type</th>
                          <th class="text-align-right padding-top-0px padding-bottom-0px">Base Price</th>
                          <th class="padding-top-0px padding-bottom-0px">Can Edit</th>
                        </tr>
                      </thead>
                      <tbody class="table-body">
                        <tr *ngFor="let l of CurrentServicesByCategoryCodeController2">
                          <td class="padding-top-0px padding-bottom-0px"><a class="nav-link-hand table-anchor">{{l.Code}}</a></td>
                          <td class="padding-top-0px padding-bottom-0px"><a class="nav-link-hand table-anchor">{{l.ServiceName}}</a></td>


                          <td class="text-align-left padding-top-0px padding-bottom-0px">
                            {{l.CategoryName}}

                          </td>
                          <td class="text-align-left padding-top-0px padding-bottom-0px">
                            {{l.RevenueCategory}}

                          </td>
                          <td class="text-align-left padding-top-0px padding-bottom-0px">
                            {{l.ServiceType}}

                          </td>
                          <td class="text-align-right font-weight-bold padding-top-0px padding-bottom-0px">
                            {{l.BasePrice}}
                          </td>
                          <td class="text-align-center padding-top-0px padding-bottom-0px">
                            <i class="fa fa-check float-none tick-mark-styles" *ngIf="l.EditApprovalREquired"></i>

                          </td>
                          <td class="padding-top-0px padding-bottom-0px">
                            <a *canUserAccess="['HL_SV_SET_10']"
                               (click)="edit(l)" class="nav-link-hand education-navlink" tooltip="Edit">
                              <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                            </a>

                            <a  *canUserAccess="['HL_SV_SET_11']"
                               (click)="svc_provider(l)" class="nav-link-hand education-navlink" tooltip="Provider">
                              <span class="badge font-size-14"><i class="fa fa-user-md" aria-hidden="true"></i></span>
                            </a>
                          </td>
                        </tr>

                      </tbody>

                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
      </div>

    </div>


